import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { LativHttpClient } from '@service/lativ.interceptor';
import { WindowDetectService } from '@service/window-detect.service';

@Injectable({
  providedIn: 'root',
})
export class LativPrefetcher {
  static readonly prefetchPaths = ['v2/home/mini', 'v1/search/keywords'];
  static readonly singlePaths: string[] = [
    'v2/home/sales_event?eventId=&eventCategory=&mode=MODE_UNSPECIFIED&adId=&adSeq=0',
  ];
  static readonly prefetchHeader = 'lativ-prefetch';

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private windowDetectService: WindowDetectService,
    private http: LativHttpClient
  ) {}

  static shouldCache(url: string | undefined | null): boolean {
    return (
      LativPrefetcher.prefetchPaths.some(p => url?.includes(p)) ||
      LativPrefetcher.singlePaths.some(p => url?.includes(p))
    );
  }

  /**
   * Prefetch api result to @link{TransferState}. Note that, once the response is cached, it will never be evicted.
   * You should refresh it by calling fetch again.
   */
  doPrefetch(): void {
    if (
      isPlatformServer(this.platformId) ||
      this.windowDetectService.isShortUrlWebsite() ||
      this.windowDetectService.isLegacyWebsite() ||
      this.windowDetectService.isWebsiteForApp()
    ) {
      return;
    }
    LativPrefetcher.prefetchPaths.forEach(p =>
      this.http.get(p, undefined, { [LativPrefetcher.prefetchHeader]: p }).subscribe()
    );
  }

  /**
   * Prefetch single path data to @link{TransferState}.
   * @param path target path
   */
  prefetchSinglePath(path: string): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    if (LativPrefetcher.singlePaths.includes(path)) {
      return;
    }
    LativPrefetcher.singlePaths.push(path);
    this.http.get(path, undefined, { [LativPrefetcher.prefetchHeader]: path }).subscribe();
  }
}
